export const spring = {
  type: 'spring',
  stiffness:  500,
  damping:  30,
};
